import {Component} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {FieldContainerComponent} from '@shared/form/field-container/field-container.component';
import {StringFieldBaseComponent} from '@shared/form/string/string-field-base.component';
import {CharsLeftComponent} from '@shared/form/string/chars-left/chars-left.component';
import {AutosizeTextareaDirective} from '@domain/common/directive/autosize-textarea.directive';

@Component({
  selector: 'app-text-field',
  imports: [
    ReactiveFormsModule,
    FieldContainerComponent,
    CharsLeftComponent,
    AutosizeTextareaDirective
  ],
  templateUrl: './text-field.component.html',
  styleUrl: './text-field.component.scss'
})
export class TextFieldComponent extends StringFieldBaseComponent {
}
